import type { Editor } from '@tiptap/core';
import { posToDOMRect } from '@tiptap/core';

import type { ModalService } from './../../ricos-modals';
import type { Modal, Placement } from './../../ricos-types';
import type { NamedLink } from './../link/types';

import { LINK_MODAL_ID } from './constants';
import { LinkModal } from './open-link-modal/link-modal';

export const openLinkModal = ({
  editor,
  initialValue,
  modalService,
  onClickOutside,
  onSave,
  onSaveMultiple,
  onUnlink,
  placement,
  referenceElement: argReferenceElement,
}: {
  editor?: Editor;
  initialValue?: NamedLink | undefined;
  modalService: ModalService;
  onClickOutside?: Modal['onClickOutside'];
  onSave: (linkData: NamedLink) => void;
  onSaveMultiple?: (links: NamedLink[]) => void;
  onUnlink: (linkData: NamedLink) => void;
  placement?: Placement;
  referenceElement?: HTMLElement | null;
}) => {
  const referenceElement = argReferenceElement
    ? argReferenceElement
    : editor
    ? {
        getBoundingClientRect: () =>
          posToDOMRect(
            editor.view,
            editor.view.state.selection.from,
            editor.view.state.selection.to
          ),
      }
    : null;

  modalService.openModal({
    Component: LinkModal,
    componentProps: {
      initialValue,
      onClose: () => modalService.closeModal(LINK_MODAL_ID),
      onSaveMultiple,
      onSave,
      onUnlink,
    },
    disableArrowNavigation: true,
    dragHandleSelector: '[data-drag-handler]',
    enableDrag: true,
    id: LINK_MODAL_ID,
    layout: {
      desktop: referenceElement ? 'floating' : 'dialog', //TODO: get layout value directly
      mobile: 'fullscreen',
    },
    noPadding: true,
    ...(referenceElement && {
      positioning: { placement: placement ?? 'bottom', referenceElement },
    }),
    withTransition: true,
    ...(onClickOutside ? { onClickOutside } : {}),
  });
};
